import React from 'react';
import { observer } from 'mobx-react';

import * as S from './CardHoverOverlay.style';
import Image from '../image/Image';

const CardHoverOverlay = observer(
	({ title, subTitle, description, uiStyle, backColor, imageSrc, date }) => {
		const isNotice = title === '공지사항';

		const isNewByDate = (dateString) => {
			if (!dateString) return false;
			const now = new Date();
			const date = new Date(dateString.replace(/-/g, '/'));
			const diff = (now - date) / (1000 * 60 * 60 * 24);
			return diff <= 15 && diff >= 0;
		};
		const isNew = isNotice && date && isNewByDate(date);

		return (
			<S.Container uiStyle={uiStyle} backColor={backColor}>
				<pre className='sub'>{subTitle}</pre>
				<pre className='title'>
					{title}
					{isNew && <S.NewBadge className={uiStyle}>new</S.NewBadge>}
				</pre>
				{uiStyle === 'small' ? <Image srcArray={[imageSrc]} /> : <></>}
				<p>{description}</p>
				{uiStyle === 'small' && (
					<S.ShortCutButton uiStyle={uiStyle}>
						<p>바로가기</p>
						<Image srcArray={S.shortcut_list} />
					</S.ShortCutButton>
				)}
			</S.Container>
		);
	},
);

export default CardHoverOverlay;
